import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * useMenuData
 * @param data data-blob to define menu structure
 * @param endpoint API endpoint to query for menu structure
 * @returns
 */
export const useMenuData = ({ endpoint, externalData, onMount, }) => {
    const initialData = {
        fetched: false,
        loaded: false,
    };
    const headerRef = useRef(null);
    // fetch & annotate menu data from D8's api
    const getData = useCallback(async (endpoint) => {
        // Get menu data from D8 API
        const data = await fetch(endpoint || '')
            .then((response) => response.json())
            .then((data) => {
            return data;
        })
            .catch((error) => {
            console.warn('There was a problem fetching the Global Menu data:');
            console.warn(error);
            return {};
        });
        if (data) {
            // Make a note that the fetch completed
            data.fetched = true;
            // If any basic data was received, mark the data as loaded
            data.loaded = !!(data === null || data === void 0 ? void 0 : data.logo) || !!(data === null || data === void 0 ? void 0 : data.translatableText) || false;
            setData(data);
        }
    }, []);
    // If data is passed in manually, start with that
    // If both data and an endpoint are passed in, start with data, but still listen for the endpoint???
    const [data, setData] = useState(externalData || initialData);
    // Provide an onMount callbacck for consumers to hook into, only once the data's finished loading
    useEffect(() => {
        if (headerRef && headerRef.current && data.fetched && onMount) {
            onMount(headerRef.current);
        }
    }, [data.fetched, onMount]);
    // If the endpoint changes, make sure to call fresh data
    useEffect(() => {
        if (data.fetched && endpoint) {
            getData(endpoint);
        }
    }, [data.fetched, endpoint, getData]);
    // If there's no data (eg. on the first render), make sure to call for data
    useEffect(() => {
        if (!data.fetched && endpoint) {
            getData(endpoint);
        }
    }, [data, endpoint, getData]);
    return {
        data,
        headerRef,
    };
};
